import { useContext } from 'react';
import { SummaryContext } from '../summary-provider';

export function useSummaryContext() {
  const ctx = useContext(SummaryContext);

  if (!ctx) {
    throw new Error('Unknown summary widget context');
  }

  return ctx;
}
